import { ApiProperty } from "@nestjs/swagger"
import { IsArray, IsString, ArrayMinSize, IsNotEmpty } from "class-validator"

export class RemoveChapterConceptDto {
  @ApiProperty({
    type: 'string',
    description: 'ID du concept à retirer',
    example: 'concept-uuid-1',
  })
  @IsNotEmpty()
  @IsString()
  programConceptId!: string
}